class MediaGallery extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      liveRegion: this.querySelector('[id^="GalleryStatus"]'),
      viewer: this.querySelector('[id^="GalleryViewer"]'),
      thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
      dots: this.querySelector('[id^="GalleryDots"]')
    };
    this.mql = window.matchMedia('(min-width: 750px)');
    if (!this.elements.thumbnails) return;
    this.setupEventListeners();

    if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) {
      this.removeListSemantic();
    }

    this.autoplay = true;
    this.advanceHandler = this.autoplayAdvance.bind(this);
  }

  connectedCallback() {
    this.autoplay = this.dataset.autoAdvance === 'true';

    // launch the first element
    this.setActiveMedia(this.elements.viewer.slider.querySelector('.slider__slide:first-child').dataset.mediaId, false, 'auto');
  }

  setupEventListeners() {
    this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));

    this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
      mediaToSwitch.querySelector('button').addEventListener('click', () => {
        this.setActiveMedia(mediaToSwitch.dataset.target, false, 'click');
      });
    });
    if (this.elements.dots) {
      this.elements.dots.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', () => {
          this.setActiveMedia(mediaToSwitch.dataset.target, false, 'click');
        });
      });
    }
  }

  onSlideChanged(event) {
    if (this.autoplay) return;

    const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${event.detail.currentElement.dataset.mediaId}"]`);
    this.setActiveThumbnail(thumbnail);

    const dot = this.elements.dots.querySelector(`[data-target="${event.detail.currentElement.dataset.mediaId}"]`);
    this.setActiveDot(dot);

    this.setActiveMedia(event.detail.currentElement.dataset.mediaId, false, 'auto');
  }

  setActiveMedia(mediaId, prepend, event) {
    const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
    let videoElement = activeMedia.querySelector('video');
    this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
      element.classList.remove('is-active');
    });
    activeMedia.classList.add('is-active');

    if (event !== 'auto') {
      clearInterval(this.autoplayInterval);
      this.autoplay = false;
      if (videoElement) videoElement.loop = true;
    }

    if (videoElement) {
      videoElement.load()
    }

    if (prepend) {
      activeMedia.parentElement.prepend(activeMedia);
      if (this.elements.thumbnails) {
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        activeThumbnail.parentElement.prepend(activeThumbnail);
      }
      if (this.elements.dots) {
        const activeDot = this.elements.dots.querySelector(`[data-target="${mediaId}"]`);
        activeDot.parentElement.prepend(activeDot);
      }
      if (this.elements.viewer.slider) this.elements.viewer.resetPages();
    }

    this.preventStickyHeader();
    window.setTimeout(() => {
      if (this.elements.thumbnails) {
        activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
      }
      if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
        activeMedia.scrollIntoView({ behavior: 'smooth' });
      }
    });
    const loadedVideo = this.playActiveMedia(activeMedia);

    if (loadedVideo && !this.autoplay) {
      loadedVideo.loop = true;
    }

    if (!this.elements.thumbnails) return;
    const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
    this.setActiveThumbnail(activeThumbnail);
    if (this.elements.dots) {
      const activeDot = this.elements.dots.querySelector(`[data-target="${mediaId}"]`);
      this.setActiveDot(activeDot);
    }
    this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);

    // set the next one - timeout to let the video load
    setTimeout(() => {
      if (this.autoplay) {
        // assuming it could get loaded now
        let videoElement = activeMedia.querySelector('video');
        if (videoElement) {
          videoElement.addEventListener("ended", this.advanceHandler, {once: true});
        } else {
          setTimeout(this.advanceHandler, 6000);
        }
      }
    }, 1000);
  }

  setActiveThumbnail(thumbnail) {
    if (!this.elements.thumbnails || !thumbnail) return;
    this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
    thumbnail.querySelector('button').setAttribute('aria-current', 'true');
    if (!this.elements.thumbnails.isFirstSlideInViewport(thumbnail, 10)) {
      this.elements.thumbnails.slider.scrollTo({ left: -thumbnail.getBoundingClientRect().width });
    }
    if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;
    this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft - thumbnail.getBoundingClientRect().width });
  }

  setActiveDot(dot) {
    if (!this.elements.dots || !dot) return;
    this.elements.dots.querySelectorAll('button').forEach((element) => {
      element.removeAttribute('aria-current')
      element.classList.remove('active');
    });
    dot.querySelector('button').setAttribute('aria-current', 'true');
    dot.querySelector('button').classList.add('active');
  }


  announceLiveRegion(activeItem, position) {
    const image = activeItem.querySelector('.product__modal-opener--image img');
    if (!image) return;

    image.onload = () => {
      this.elements.liveRegion.setAttribute('aria-hidden', 'false');
      this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
      setTimeout(() => {
        this.elements.liveRegion.setAttribute('aria-hidden', 'true');
      }, 2000);
    };
    image.src = image.src;
  }

  playActiveMedia(activeItem) {
    window.pauseAllMedia();
    const deferredMedia = activeItem.querySelector('.deferred-media');
    if (deferredMedia) {
      deferredMedia.loadContent(false);
      /** @type HTMLVideoElement */
      const video = activeItem.querySelector('video');
      video.play();
      return video;
    }
  }

  preventStickyHeader() {
    this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
    if (!this.stickyHeader) return;
    this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
  }

  removeListSemantic() {
    if (!this.elements.viewer.slider) return;
    this.elements.viewer.slider.setAttribute('role', 'presentation');
    this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
  }

  autoplayAdvance() {
    if (!this.autoplay) return;

    /** @type HTMLElement */
    const activeElement = this.elements.viewer.slider.querySelector('.is-active');
    /** @type HTMLElement */
    const nextElement = activeElement.nextElementSibling ?? this.elements.viewer.slider.querySelector('.slider__slide:first-child');

    this.setActiveMedia(nextElement.dataset.mediaId, false, 'auto');
  }

}

if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', MediaGallery);
}
